import React, { Fragment, useEffect, useState } from 'react';
import {
  Box,
  Cluster,
  CollapsibleSection,
  Motion,
  SolidDivider,
} from '@thecb/components';
import ProductTile from './ProductTile';

const ProductsSection = ({
  title,
  products,
  id,
  universalExpandCollapseState,
}) => {
  const [isOpen, setIsOpen] = useState(true);
  useEffect(() => {
    if (universalExpandCollapseState.lastEvent === 'COLLAPSED_ALL' && isOpen) {
      setIsOpen(false);
    }
    if (universalExpandCollapseState.lastEvent === 'EXPANDED_ALL' && !isOpen) {
      setIsOpen(true);
    }
  }, [universalExpandCollapseState]);

  if (!products.length) return null;

  return (
    <Fragment>
      <Box id={`agency-${id}`} padding="16px 0">
        <CollapsibleSection
          supportsTouch={false}
          isOpen={isOpen}
          title={title}
          initiallyOpen={true}
          toggleSection={() => setIsOpen(!isOpen)}
          customTitle={false}
        >
          <Motion
            variants={{
              open: { opacity: 1 },
              closed: { opacity: 0 },
            }}
            initial={'open'}
          >
            <Cluster
              justify="flex-start"
              align="stretch"
              childGap="7px"
              extraStyles={'padding: 1rem 0;'}
            >
              {products.map((product) => (
                <ProductTile
                  key={product.id}
                  id={product.id}
                  text={product.name}
                  validated={product.validated}
                />
              ))}
            </Cluster>
          </Motion>
        </CollapsibleSection>
      </Box>
      <SolidDivider />
    </Fragment>
  );
};

export default ProductsSection;
